import { defineComponent as _defineComponent } from 'vue'
import { computed, defineAsyncComponent, ref, watch } from 'vue'
import Edit from '~/components/icons/Edit.vue'
import TrashcanFilled from '~/components/icons/TrashcanFilled.vue'
import type { Painting } from '~/types/dto/Painting'
type PaintingCardProps = {
  item: Painting,
  limitImage?: boolean,
  displayArtist?: boolean,
  containImage?: boolean,
  blockImageSized?: boolean,
  canBuy?: boolean,
  showStoreStatus?: boolean,
  showEditButtons?: boolean,
  noLink?: boolean,
  customLink?: string,
  tags: any
  showInSale: boolean
}

type ImageLoadedType = {
  success: true,
  imgEl: HTMLElement
} | {success: false, imgEl: null}

type PaintingCardEmits = {
  (e: 'image-loaded', value: ImageLoadedType),
  (e: 'painting-changed', value: Painting),
  (e: 'delete')
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PaintingCard',
  props: {
    item: null,
    limitImage: { type: Boolean, default: true },
    displayArtist: { type: Boolean, default: true },
    containImage: { type: Boolean, default: false },
    blockImageSized: { type: Boolean, default: false },
    canBuy: { type: Boolean, default: true },
    showStoreStatus: { type: Boolean, default: false },
    showEditButtons: { type: Boolean, default: false },
    noLink: { type: Boolean, default: false },
    customLink: { default: '' },
    tags: null,
    showInSale: { type: Boolean, default: false }
  },
  emits: ["image-loaded", "painting-changed", "delete"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'image-loaded', value: ImageLoadedType),
  (e: 'painting-changed', value: Painting),
  (e: 'delete')
}), expose: any, slots: any, attrs: any }) {

const props = __props as { item: Painting, limitImage: boolean, displayArtist: boolean, containImage: boolean, blockImageSized: boolean, canBuy: boolean, showStoreStatus: boolean, showEditButtons: boolean, noLink: boolean, customLink: string, tags: any, showInSale: boolean };

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Clock = defineAsyncComponent(() => import('~/components/icons/Clock.vue'))
const Xmark = defineAsyncComponent(() => import('~/components/icons/Xmark.vue'))
const AddArtworkModal = defineAsyncComponent(() => import('~/components/new/modals/AddArtworkModal.vue'))
const BaseModalDialog = defineAsyncComponent(() => import('~/components/new/ui/BaseModalDialog.vue'))
const BuyPaintingModal = defineAsyncComponent(() => import('~/components/new/modals/BuyPaintingModal.vue'))

const apiEndpoint = process.env.API_ENDPOINT

const imgEl = ref<HTMLImageElement>()



const imgLoaded = ref(false)
const dialog = ref(false)

const initial = ref<Painting | null>(null)

const href = computed(() => {
  if (props.customLink) {
    return props.customLink
  } else {
    return `/artists/${props.item?.artist?.url}/${props.item?.id}`
  }
})

const buyModal = ref(false)
const paintingBuyHandler = () => {
  buyModal.value = true
}

const imageLoaded = (state: boolean) => {
  if (!imgEl.value) { return }

  if (!state) {
    emit('image-loaded', { success: false, imgEl: null })
    return
  }

  emit('image-loaded', { success: true, imgEl: imgEl.value })
  imgLoaded.value = true
}

const editPaintingHandler = (payload: Painting[]) => {
  initial.value = null
  emit('painting-changed', payload[0])
}


return { __sfc: true,Clock, Xmark, AddArtworkModal, BaseModalDialog, BuyPaintingModal, apiEndpoint, imgEl, props, imgLoaded, dialog, emit, initial, href, buyModal, paintingBuyHandler, imageLoaded, editPaintingHandler, Edit, TrashcanFilled }
}

})